import { Toolbar } from 'primereact/toolbar';
import { FC } from 'react';
import ReportHubContainer from '../components/ReportHub/ReportHubContainer';
import ReportHubBreadcrumb from '../components/ReportHub/ReportHubBreadcrumb';
import { useSideNavActive } from '../components/LayoutWrapper/SideNavLayoutContext';

const ReportHub: FC = () => {
  const sideNavActive = useSideNavActive();

  const pageTitleCenter = () => {
    return <h1>Reports Hub</h1>;
  };
  return (
    <div className="nc_page-inner nc_page-side-margin flex-grow-1 overflow-x-hidden">
      <div className="grid">
        <div className="col-10 col-offset-1 flex flex-column nc_content-frame">
          {!sideNavActive && (
            <>
              <Toolbar role="section" center={pageTitleCenter} className="nc_page-header" />
              <ReportHubBreadcrumb />
            </>
          )}
          <ReportHubContainer />
        </div>
      </div>
    </div>
  );
};

export default ReportHub;
